import type { PublicUser } from '@sirocco/shared';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from '../../components/ui/Avatar';
import { useLongPress } from '../../hooks/useLongPress';


/** Une ligne de membre : avatar, pseudo, une precision, et les actions. */
export function PersonRow({
  member,
  note,
  onHold,
  children,
}: {
  member: PublicUser;
  /**
   * Une precision sous le pseudo, quand il y en a une a donner.
   *
   * Absente, la ligne s'en tient au nom. « Confirme » sous chaque
   * participant d'une liste de participants ne disait rien que la liste
   * ne disait deja, et repete trente fois il chargeait l'ecran.
   */
  note?: string;
  /** Appui long sur la ligne. Absent : la ligne ne fait rien de plus. */
  onHold?: () => void;
  children?: ReactNode;
}) {
  /*
    Toujours la fiche, jamais l'onglet Profil.

    Ailleurs, son propre pseudo mene a son onglet — voir `profilePath`.
    Ici non : on parcourt une liste de participants, et s'en voir retire
    d'un coup pour atterrir dans ses reglages casse la lecture. C'est la
    meme page pour tout le monde, la sienne comprise.
  */
  const memberPath = `/app/members/${member.id}`;
  const hold = useLongPress(() => onHold?.());

  return (
    /*
      Une ligne, pas une carte : un organisateur qui trie ses demandes en
      voit une dizaine d'un coup plutot que quatre.
    */
    <div className="ev-person" {...(onHold ? hold : {})}>
      <Link to={memberPath} aria-label={member.username}>
        <Avatar user={member} size={36} />
      </Link>

      <div className="ev-person__body">
        <Link to={memberPath} className="ev-person__name">
          {member.username}
        </Link>
        {note && <p className="ev-person__note">{note}</p>}
      </div>

      {children}
    </div>
  );
}
